/**
 * The geometry and the gentle-shake math behind the bulb glyphs. The globe's
 * center is exported for the on-variant's rays, which radiate from it, and
 * BulbBody draws the bulb these numbers describe.
 *
 * The shake is a decaying wobble around the bulb's base: two full
 * back-and-forths (four swings) whose swing shrinks to nothing at both ends
 * of the cycle, so rest (0) and a whole cycle (1) draw the upright bulb.
 */// The globe's center — rays radiate from here, and the sizes below hang
// off it, so nudging the center moves the whole lit crown together. It
// rides high enough to leave a clear gap between the globe and the neck
// bar below it.
export const GLOBE_CENTER_X=12;export const GLOBE_CENTER_Y=9.2;export const GLOBE_RADIUS=4.6;// The wobble pivots at the bulb's base, so the globe sways like a tipped
// lamp rather than sliding sideways.
const SHAKE_PIVOT_X=12;const SHAKE_PIVOT_Y=19.4;// Two full back-and-forths per cycle (sin(2 * TAU * p) swings four times),
// shaped by a half-sine envelope so the wobble fades in and out.
export function shakeTransform(progress,amplitudeDegrees){if(progress===0){return undefined;}const swing=Math.sin(2*2*Math.PI*progress);const envelope=Math.sin(Math.PI*progress);const angle=amplitudeDegrees*swing*envelope;return"rotate(".concat(angle," ").concat(SHAKE_PIVOT_X," ").concat(SHAKE_PIVOT_Y,")");}